import { BaseFiltroPagDTO } from "./base-dto";

export default interface IPatient {
  id: string;
  text?: string;
  nome?: string;
  tipo?: any;
  nascimento: string;
  idade?: string;
  idadeAMD?: string;
  idadeAMDPrescr?: string;
  peso: Number;
  pesoCalorico: Number;
  imc: any;
  sexo: string;
  registro?: string;
  same?: string;
  termo?: string;
  setor?: string;
  leito?: string;
  convenio?: any;
  clientes?: any[];
  unidades?: any[];
  enderecos?: any[];
  ativo?: boolean;
}

export type TypePatient = 'NEO_NATAL' | 'ADULTO' | 'PEDIATRICO';

export class PacienteFiltroDTO extends BaseFiltroPagDTO {
  nome: string;
  idUnidade: number;
  nascimento:string;
  sexo:string;
  ativo: Boolean;
  agrupado: Boolean;
  idNaoIncluir: number;
}

export class PacienteAgrupadoParmDTO {
  ids: number[];
  nome: string;
  nascimento: string;
  peso: number;
  sexo: string;
  termo: string;
  same: string;
  ativo: Boolean;
}

export class PacienteParmDTO {
  id: number;
  nome: string;
  nascimento: string;
  peso: number;
  sexo: string;
  termo: string;
  same: string;
  ativo: boolean;
  idsUnidades: number[];
  idsEnderecos: number[];
  idUnidadePrescrever: number;
}

export class PacienteExistFiltrosDTO {
  idsUnidade: number[];
  nomePaciente: string;
  nascimento: string;
}